import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { isFailure } from "../../common/actions/VisitApi";
import { RootState } from "../../state";
import { requestToFollowCompany, requestToUnfollowCompany } from "../api";

const actionCreator = actionCreatorFactory("COMPANY_FOLLOWINGS");

export const followCompany = actionCreator.async<RootState, EntityId, EntityId, Error>("FOLLOWED");
export const unfollowCompany = actionCreator.async<RootState, EntityId, EntityId, Error>("UNFOLLOWED");

export const followCompanyWorker = bindThunkAction(followCompany, async (params, dispatch) => {
  const req = requestToFollowCompany(params);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return params;
});

export const unfollowCompanyWorker = bindThunkAction(unfollowCompany, async (params, dispatch) => {
  const req = requestToUnfollowCompany(params);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return params;
});



// WEBPACK FOOTER //
// ./frontend/src/company_followings/actions/index.ts